<template>
  <SystemBarSpacer></SystemBarSpacer>
  <header v-if="!Capacitor.isNativePlatform()" class="sticky-top">
    <NavBarWeb></NavBarWeb>
    <div class="progressbar w-100" v-if="progressing"></div>
    <div class="progressbar-spacer" v-else></div>
  </header>
  <header v-else class="fixed-bottom">
    <div class="progressbar w-100" v-if="progressing"></div>
    <div class="progressbar-spacer" v-else></div>
    <NavBarMobile></NavBarMobile>
  </header>
</template>

<script setup lang="ts">
import { useMainStore } from '~/stores/main'
import { storeToRefs } from 'pinia'
import { Capacitor } from '@capacitor/core'
import NavBarMobile from './NavBarMobile.vue'
import NavBarWeb from './NavBarWeb.vue'
import SystemBarSpacer from './SystemBarSpacer.vue'

const store = useMainStore()
const { progressing } = storeToRefs(store)
</script>

<style lang="scss">
.progressbar {
  position: relative;
  height: 10px;
  top: 0;
  background: no-repeat linear-gradient($primary 0 0);
  background-size: 60%;
  animation: progress-animation 1.2s linear infinite;
}

.progressbar-spacer {
  position: relative;
  height: 10px;
  top: 0;
}

@keyframes progress-animation {
  0% {
    background-position: -150% 0;
  }

  100% {
    background-position: 250% 0;
  }
}
</style>
